import { render } from "./addProduct.vue?vue&type=template&id=b18a9a4e&scoped=true&ts=true"
import script from "./addProduct.vue?vue&type=script&lang=ts"
export * from "./addProduct.vue?vue&type=script&lang=ts"

import "./addProduct.vue?vue&type=style&index=0&id=b18a9a4e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18a9a4e"]])

export default __exports__